import { ActivityAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { ActivityDashboardModel } from 'src/app/models/model'

export interface ActivityState {
  dashboard: ActivityDashboardModel
  details: ActivityAPIModel
  summary: PaginatedAPI<ActivityAPIModel>
}

export const initialActivityState: ActivityState = {
  dashboard: undefined,
  details: undefined,
  summary: undefined
}
